import axios from 'axios';

const api = axios.create({baseURL : 'https://www.sistemaimperium.com.br/simpauth'});
// const api = axios.create({baseURL : 'https://www.sistemaimperium.com.br/simpauthteste'});

// const api = axios.create({baseURL : 'http://localhost:9501'});

export default api;